
import Splitter from "./splitter/splitter";
function App() {
  return (
    <div className="container">
      <h1>React image splitter</h1>
      <Splitter />
    </div>
  );
}

export default App;
